import { ContactTemplatePage } from '.';

export const ContactPoliceContent = () => {
  return (
    <div className="text-bodyLg flex flex-col gap-4">
      <p>
        If the vehicle has been involved in an accident or could cause one if
        left in its current position, it is best to contact the police as they
        deal with this type of issue.
      </p>
      <p>
        <a
          href="https://www.police.uk/pu/contact-us/a-road-traffic-incident/"
          target="_blank"
          rel="noreferrer"
          className="text-link-colour underline"
        >
          Report it online to the police
        </a>
      </p>
      <p>
        <span className="font-bold">Telephone:</span>
        {` `}101
      </p>
      <p>
        <span className="font-bold">Hearing or speech impairments:</span>
        {` `}If you have a hearing or speech impairment, use their textphone
        service 18001 101.
      </p>
    </div>
  );
};

export const ContactPolicePage = () => {
  return (
    <ContactTemplatePage
      title="Contact the police"
      content={<ContactPoliceContent />}
    />
  );
};
